import { Injectable } from '@angular/core';
import { PrintCardContentViewModel } from '../../shared/print-card-content-view-model';
import { map } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { PrimaryCannabinoid } from '../../../../../../../models/enum/shared/cannabinoid';
import { SortUtils } from '../../../../../../../utils/sort-utils';
import { PropertyPoolSorter } from '../../shared/card-data-with-property-pooling';

@Injectable()
export class DougIndexCardStackContentViewModel extends PrintCardContentViewModel {
  private readonly pinnedSecondaryPropertyMap = new Map<string, number>([
    [PrimaryCannabinoid.THC, 0],
    [PrimaryCannabinoid.CBD, 1]
  ]);

  public readonly propertiesToDisplay$ = this.propertiesBasedOnPools$;

  public readonly gridPropertiesBasedOnPools$ = this.getGridPropertiesBasedOnPools$(this.spoofedGridColViewModels$);

  public titleMaxWidth$ = combineLatest([this.cardData$, this.isLineItemMode$]).pipe(
    map(([cardData, isLineItemMode]) => {
      const numOfCols = isLineItemMode ? 1 : cardData?.rowVariants?.length;
      switch (numOfCols) {
        case 2:
          return '11rem';
        case 3:
          return '8rem';
        default:
          return '13rem';
      }
    })
  );

  public badgeAndLabelMaxWidth$ = combineLatest([this.cardData$, this.isLineItemMode$]).pipe(
    map(([cardData, isLineItemMode]) => {
      const numOfCols = isLineItemMode ? 1 : cardData?.rowVariants?.length;
      switch (numOfCols) {
        case 2:
          return '8rem';
        case 3:
          return '6rem';
        default:
          return '10rem';
      }
    })
  );

  public gridHas3Columns$ = this.cardData$.pipe(map(cardData => cardData?.rowVariants?.length === 3));

  protected override emptyPropertyValueForPropertiesBasedOnPools(): string {
    return '-';
  }

  protected override finalSortLambdaForCompoundProperties(): PropertyPoolSorter {
    return (a, b) => SortUtils.pinned(this.pinnedSecondaryPropertyMap, a?.title, b?.title);
  }

  protected override getSecondaryPoolOfCompoundPropertiesSortLambda(): PropertyPoolSorter {
    const defaultSort = super.getSecondaryPoolOfCompoundPropertiesSortLambda();
    return (a, b) => SortUtils.pinned(this.pinnedSecondaryPropertyMap, a?.title, b?.title) || defaultSort(a, b);
  }
}
